<template>
  <div>
    <Header>

    </Header>

    <PageContainer>
      <div class="iqos-grid">
        <div class="iqos-column">
          <OrderStatusNotifications />
          <ClientAuthorizationPanel />
          <!-- <PublicBetaPanel /> -->
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import OrderStatusNotifications from '@/components/clientapp/OrderStatusNotifications.vue'

import ClientAuthorizationPanel from '@/components/clientapp/ClientAuthorizationPanel.vue'

import PublicBetaPanel from '@/components/inside/PublicBetaPanel.vue'

export default {
  components: {
    OrderStatusNotifications,
    ClientAuthorizationPanel,
    PublicBetaPanel
  }
}
</script>

<style>
</style>